import { render, staticRenderFns } from "./stickerModel.vue?vue&type=template&id=0063d6f0&lang=pug&"
import script from "./stickerModel.vue?vue&type=script&lang=js&"
export * from "./stickerModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports